
import React from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { ElfNameGeneratorTheme } from "./ElfNameGeneratorTheme";

interface GeneratorFormProps {
  fullName: boolean;
  setFullName: (value: boolean) => void;
  onGenerate: () => void;
  isGenerating: boolean;
}

export const GeneratorForm: React.FC<GeneratorFormProps> = ({
  fullName,
  setFullName,
  onGenerate,
  isGenerating
}) => {
  return (
    <div className={ElfNameGeneratorTheme.form}>
      <div className="text-center mb-4">
        <p className="text-gray-700">
          Select whether you want to generate a full elf name or just a first name:
        </p>
      </div>
      
      <div className={ElfNameGeneratorTheme.radioGroup}>
        <label className={ElfNameGeneratorTheme.radioLabel}>
          <input
            type="radio"
            className={ElfNameGeneratorTheme.radioInput}
            checked={fullName}
            onChange={() => setFullName(true)}
            disabled={isGenerating}
          />
          <span className={ElfNameGeneratorTheme.radioText}>First and Last Name</span>
        </label>
        
        <label className={ElfNameGeneratorTheme.radioLabel}>
          <input
            type="radio"
            className={ElfNameGeneratorTheme.radioInput}
            checked={!fullName}
            onChange={() => setFullName(false)}
            disabled={isGenerating}
          />
          <span className={ElfNameGeneratorTheme.radioText}>First Name Only</span>
        </label>
      </div>
      
      <button
        className={ElfNameGeneratorTheme.generateButton}
        onClick={onGenerate}
        disabled={isGenerating}
      >
        {isGenerating ? (
          <>
            <Loader2 className={ElfNameGeneratorTheme.loadingIcon} />
            Generating...
          </>
        ) : (
          <>
            <Sparkles className="mr-2 h-4 w-4" />
            Generate Your Elf Name
          </>
        )}
      </button>
    </div>
  );
};
